import React, { useState, useEffect } from "react";
import CountryServices from "services/CountryServices";
import Select from "react-select";

const SelectCountry = ({
  register,
  handleCountryChange,
  name,
  label,
  selectedCountryId,
  readOnly=false
}) => {
  const [countries, setCountry] = useState([]);

  const customSelectStyles = {
    indicatorsContainer: (provided) => ({
      ...provided,
      display: "none", // Removes the entire container including the arrow
    }),
    dropdownIndicator: () => ({
      display: "none", // Specifically removes the dropdown arrow
    }),
    indicatorSeparator: () => ({
      display: "none", // Removes the separator line
    }),
    control: (base) => ({
      ...base,
      border: "1px",
      boxShadow: "none",
      backgroundColor: "RRGGBB",
    }),
    option: (provided, state) => ({
      ...provided,
      background: state.isSelected
        ? "#0e9f6e"
        : state.isFocused
        ? "rgba(0, 0, 0, 0.15)"
        : "white",
      color: state.isSelected ? "white" : "black",
      "&:hover": {
        background: "rgba(0, 0, 0, 0.15)", // Change the background color on hover
        color: "black", // Change the text color on hover
      },
    }),
    menu: (provided) => ({
      ...provided,
      margin: "10px 0 -10px 0", // Add margin to the entire option box
    }),
  };

  useEffect(() => {
    async function fetchCountry() {
      try {
        const response = await CountryServices.getAllCountry();
        const transformedData = response.map((item) => ({
          value: item.id_country,
          label: item.name,
          call_prefix: item.call_prefix,
        }));

        // Check if India is in the list and set it as the default
        const india = transformedData.find((country) => country.value === 110);
        if (india) {
          handleCountryChange("+" + india.call_prefix, india.value);
        }

        setCountry(transformedData);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    }

    fetchCountry();
    // eslint-disable-next-line
  }, []);

  const handleCountrySelect = async (selected) => {
    const item = countries.find((item) => item.value === selected.value);
    if (item) {
      handleCountryChange("+" + item.call_prefix, selected.value);
    }
  };

  return (
    <Select
      className="block w-full focus:outline-none dark:text-white-300 leading-5 rounded-md focus:border-gray-200 border-gray-200 dark:border-gray-600 focus:ring focus:ring-green-300 dark:focus:border-white-500 dark:focus:ring-gray-300 border h-10 text-sm bg-white-100 dark:bg-white border-transparent focus:bg-white"
      {...register(`${name}`, {
        required: !selectedCountryId ? `${label} is required!` : false,
        selectedCountryId,
      })}
      name={name}
      styles={customSelectStyles}
      options={countries}
      onChange={handleCountrySelect}
      isDisabled={readOnly}
      value={countries.find((option) => option.value === selectedCountryId)}
    />
  );
};

export default SelectCountry;
